import { Formik } from "formik";
import { useAtom } from "jotai";
import { useParams, useLocation } from "react-router-dom";
import validationSchema from "./validation";
import Button from "../../components/ButtonUI";
import Input from "../../components/FloatInput";
import { login } from "../../api/auth";
import { userAtom } from "../../state/auth";
import "./stylesSignin.scss";
import logo from "../../assets/Logo.png";
import history from "../../history";
import makeToast from "../../components/Snackbar";
import { useState } from "react";
import voir from "../../assets/images/voir.png";
interface RouteParams {
  id?: string;
  name?: string;
}

const Signin: React.FC = () => {
  const [user, setUser] = useAtom(userAtom);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [passwordFormType1, setPasswordFormType1] = useState("password");

  const querySource = searchParams.get("source");
  const queryEmail = searchParams.get("email");
  const queryPassword = searchParams.get("password");

  const decodedSource = querySource
    ? decodeURIComponent(querySource)
    : undefined;
  const decodedEmail = queryEmail ? decodeURIComponent(queryEmail) : undefined;
  const decodedPassword = queryPassword
    ? decodeURIComponent(queryPassword)
    : undefined;



  const onSubmit = async (values: { email: any; password: any }) => {
    const { email, password } = values;
    try {
      const response = await login({ email, password });
      if (response.token.accessToken) {
        makeToast("success", "Vous êtes maintenant connecté");
      }

      setUser(response.user);
    } catch (error) {
      makeToast("error", " Merci, de vérifier vos informations.");
      console.error("[error] Signin - onSubmit :", error);
    }
  };

  return (
    <div className="login min-h-screen flex justify-center">
      <div className="auth-login-Container">
        <div className="flexRowCenter title-wrapper">
          <h1 className="h1 title sm:block hidden">Se connecter</h1>
        </div>
        <div className="flexCenter">
          <div className="formLogin ">
            {/* start */}
            <div
              className="icon cursor-pointer"
              onClick={() => history.push("/check/user")}
            ></div>
            <div className="logo-bloc flexRowCenter">
              <img src={logo} alt="logo" />
            </div>
            <div className="title-container flexColCenter">
              <h1 className="h1 flexRowCenter">Bienvenue</h1>
            </div>
            {decodedSource === "patient-results-email" ? (
              <p className="mb-10 text-center font-bold">
                Veuillez utiliser l'identifiant et le mot de passe temporaire
                reçus par email lors de votre première connexion
              </p>
            ) : null}
            <div className="">
              <Formik
                initialValues={{
                  email: decodedEmail || "",
                  password: decodedPassword || "",
                }}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
              >
                {(props) => {
                  const {
                    values,
                    errors,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  } = props;

                  return (
                    <>
                      <form onSubmit={handleSubmit} className="form-login relative">
                        <Input
                          id="email"
                          placeholder="Email"
                          labelText="Email"
                          type="text"
                          error={errors.email}
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inlineLabel={false}
                          onfocus={true}
                        />
                        <div className="relative w-full">
                        <Input
                          id="password"
                          placeholder="Mot de passe"
                          labelText="Mot de passe"
                          type={passwordFormType1}
                          error={errors.password}
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <img
                          src={voir}
                          alt="voir"
                          className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-3 cursor-pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            setPasswordFormType1(
                              passwordFormType1 === "password" ? "text" : "password"
                            );
                          }}
                        />
                        </div>
                        <div className="flexRowCenter">
                          <Button
                            type="submit"
                            disabled={
                              isSubmitting || Object.keys(errors).length > 0
                            }
                            status="primary"
                            className="btn"
                          >
                            Se connecter
                          </Button>
                        </div>
                      </form>
                    </>
                  );
                }}
              </Formik>
            </div>
            {decodedSource !== "patient-results-email" ? (
              <div className="create-Account flexColCenter">
                <p
                  className="create cursor-pointer"
                  onClick={() => history.push("/register")}
                >
                  S’inscrire
                </p>
                <p
                  className="create cursor-pointer"
                  onClick={() => history.push("/forgetPassword")}
                >
                  Mot de passe oublié?
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
